import * as yup from "yup";

declare module "yup" {
  export interface StringSchema {
    validateAccountNumber(message?: string): StringSchema;
  }
}

export const ACCOUNT_NUMBER_LENGTH = 8;

const DIGITS_PATTERN = new RegExp(`^\\d{${ACCOUNT_NUMBER_LENGTH}}$`);

yup.addMethod<yup.StringSchema>(
  yup.string,
  "validateAccountNumber",
  function (message = "Please, provide valid account number") {
    return this.test(
      "validate-account-number",
      message,
      function validateAccountNumber(value?: string) {
        if (!value) {
          return true;
        }

        return DIGITS_PATTERN.test(value);
      }
    );
  }
);
